<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn class="text-capitalize ms-1 font-weight-bold " :disabled="hasUpcomingPackage" color="primary" v-on="on"> <v-icon class="me-1" small>mdi-plus</v-icon>Add </v-btn>
      </template>

      <v-spacer></v-spacer>
      <v-card class="pa-6" color="light">
        <v-row>
          <v-card-title class="text-h6 dark--text mt-n2">Add Sales Order</v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="dark" @click="close" text>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <v-divider class="mb-6 mt-n2"></v-divider>
        <v-container>
          <v-form @submit="createSalesOrder()" v-model="valid" ref="form">
            <v-row class="mx-2">
              <v-radio-group v-model="pacakageSelectionMethod" @change="onPackageModeChange" color="primary">
                <v-radio value="PACKAGE" label="Choose From Packages" color="primary"> </v-radio>

                <!-- <v-radio
                  value="CELEBRITY"
                  label="Choose From Celebrity"
                  color="primary"
                >
                </v-radio> -->
              </v-radio-group>
            </v-row>
            <v-col class="mx-0 mt-n2">
              <!-- select celebrity  -->
              <!-- <v-select
                @change="choice = ''"
                v-model="selectedCelebrity"
                :items="celebrities"
                solo
                dense
                attach
                chips
                label="Choose celebrity"
                placeholder="Choose celebrity"
                return-object
                flat
                outlined
                v-if="pacakageSelectionMethod == 'CELEBRITY'"
              >
                <template slot="selection" slot-scope="data">
                  <span v-if="data.item.customer">
                    <span v-if="data.item.customer.user">
                      {{ data.item.customer.user.firstnameEn }}
                      {{ data.item.customer.user.lastnameEn }}
                    </span>
                  </span>
                </template>
                <template slot="item" slot-scope="data">
                  <span v-if="data.item.customer">
                    <span v-if="data.item.customer.user">
                      {{ data.item.customer.user.firstnameEn }}
                      {{ data.item.customer.user.lastnameEn }}
                    </span>
                  </span>
                </template>
              </v-select> -->
              <!-- {{ selectedCelebrity }} -->

              <!-- select package  -->
              <v-row class="mt-n4">
                <v-col v-if="selectedCelebrity.packages">
                  <v-select
                    @change="updateCelebityId(selectedCelebrity, selectPackage)"
                    v-model="selectPackage"
                    :items="selectedCelebrity.packages"
                    solo
                    dense
                    attach
                    chips
                    label="Choose Package"
                    placeholder="Choose Package"
                    return-object
                    flat
                    outlined
                  >
                    <template slot="selection" slot-scope="data">
                      <span v-if="data.item">
                        {{ capitalizeFirstLetter(data.item.titleEn) }}
                      </span>
                    </template>
                    <template slot="item" slot-scope="data">
                      <span v-if="data.item">
                        {{ capitalizeFirstLetter(data.item.titleEn) }}
                      </span>
                    </template>
                  </v-select>
                </v-col>

                <v-col v-if="pacakageSelectionMethod == 'PACKAGE'">
                  <v-select
                    @change="packageChange"
                    v-model="selectPackage"
                    :items="packagesList"
                    solo
                    dense
                    attach
                    :rules="[requiredValidator('plan')]"
                    item-value="_id"
                    item-text="titleEn"
                    chips
                    label="Plan"
                    return-object
                    flat
                    outlined
                  ></v-select>
                </v-col>

                <!-- slect choice  -->
                <v-col v-if="selectPackage.availableChoices" class="mx-1">
                  <v-select
                    v-model="choice"
                    :items="selectPackage.availableChoices"
                    :rules="[requiredValidator('choices')]"
                    item-value="_id"
                    dense
                    solo
                    item-text="choiceNameEn"
                    attach
                    chips
                    return-object
                    label="Choices"
                    flat
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>

            <!-- choices  -->
            <v-row class="mx-2 mt-n4">
              <label class="text-body-2 dark--text">Meal Choices</label>
            </v-row>

            <v-layout v-for="(item, index) in choice.mealChoice" :key="item._id" wrap class="mx-2 mb-5">
              <v-flex :offset-sm-2="index > 0">
                <v-card class="px-4 bg" flat>
                  <v-radio-group v-model="mealChoice" @change="onChoiceChange">
                    <v-row class="mt-4 text-h5 ms-8">
                      {{ item.variantNameEn }}
                    </v-row>
                    <v-row>
                      <v-col cols="2" sm="1" class="mt-1">
                        <v-radio :value="item"></v-radio>
                      </v-col>
                      <v-col cols="11">
                        <div v-for="(item, idxDayChoices) in item.dayChoices" :key="idxDayChoices">
                          <v-divider v-if="idxDayChoices > 0" class="my-1"></v-divider>
                          <div>
                            {{ item.day }}
                          </div>
                          <span v-for="meal in item.mealCount" :key="meal._id">
                            <span v-if="meal.category && meal.count > 0" class="mb-2 caption mt-n2"> {{ meal.count }} {{ meal.category.nameEn }} </span>
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </v-card>
              </v-flex>
            </v-layout>
            <!-- <v-divider class="mb-6"></v-divider> -->

            <v-layout wrap v-if="choice">
              <v-flex md2>
                <label class="mx-2 text-body-2 dark--text">Available Days</label>
              </v-flex>
              <v-flex lg10>
                <v-select
                  v-model="availableDays"
                  :items="listOfDays"
                  item-text="day"
                  item-value="day"
                  attach
                  dense
                  return-object
                  solo
                  chips
                  :rules="[requiredValidatorSelect('available days')]"
                  label="Available Days"
                  multiple
                  flat
                  outlined
                  :disabled="isAllowCustomerWeekDays(selectPackage)"
                >
                </v-select>
              </v-flex>
            </v-layout>

            <v-layout>
              <!-- <v-flex xs8 md2 class="mt-md-0">
              </v-flex> -->
              <v-flex>
                <div class="pt-4 pop_bg" v-for="(day, index) in [availableDays[0]]" :key="index">
                  <v-row v-if="day">
                    <v-col cols="12" md="3" class="py-0 my-0 text-body-2 dark--text ms-sm-5" v-for="(item, dayIndex) in day.allCategories" :key="item._id">
                      {{ item.nameEn }}
                      <span v-show="false">{{ dayIndex }} {{ index }}</span>

                      <v-text-field @change="checkPackagePrice" :label="item.nameEn + '(No.)'" solo flat outlined type="number" @keypress="isNumber" v-model="item.count" min="0" dense></v-text-field>
                    </v-col>
                  </v-row>
                </div>

                <!-- <v-select
                  v-model="choice.availableDays"
                  :items="choice.availableDays"
                  multiple
                  disabled
                  dense
                  attach
                  solo
                  label="Choices"
                  class="dark--text"
                ></v-select> -->
              </v-flex>
            </v-layout>
            <!-- && selectPackage -->
            <v-layout wrap class="mt-3">
              <v-flex xs12 sm2 v-if="!hasActivePackage">
                <label class="dark--text text-body-2 ms-2">Start date</label>
              </v-flex>
              <!-- <v-flex xs8 md2 class="mt-md-0">
              </v-flex> -->
              <v-flex xs12 sm3 lg4 pe-lg-6 v-if="!hasActivePackage">
                <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      solo
                      dense
                      label="Start Date"
                      :value="formatDate"
                      append-icon="fa-calendar-alt dark--text"
                      readonly
                      :rules="[requiredValidator('start date')]"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker color="primary" v-model="start_date" @input="menu1 = false" :landscape="landscape" :reactive="reactive"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm2 v-if="choice">
                <label class="pt-4 dark--text text-body-2">Package Days</label>
              </v-flex>

              <v-flex xs12 sm4 v-if="choice">
                <v-text-field :value="choice.availableNumOfDays" solo disabled dense flat outlined> </v-text-field>
              </v-flex>
            </v-layout>

            <v-layout v-if="choice">
              <v-flex xs12 sm2>
                <label class="pt-4 dark--text text-body-2">Additional Days</label>
              </v-flex>

              <v-flex xs12 sm4 lg4 pe-sm-6>
                <v-text-field @change="checkPackagePrice" v-model="additionalDays" solo :rules="positiveNoRule" type="number" min="0" dense flat outlined> </v-text-field>
              </v-flex>
            </v-layout>

            <v-layout v-if="choice" wrap>
              <v-flex xs12 sm2>
                <label class="pt-4 text-body-2 dark--text">Protein</label>
              </v-flex>
              <v-flex xs12 sm4 lg4 pe-sm-6>
                <h4 class="text-body-2">
                  <v-select
                    @change="checkPackagePrice"
                    :items="[
                      { value: '50', text: '50' },
                      { value: '100', text: '100' },
                      { value: '150', text: '150' },
                      { value: '200', text: '200' },
                    ]"
                    v-model="protein"
                    outlined
                    dense
                    type="number"
                    min="0"
                  >
                  </v-select>
                </h4>
              </v-flex>

              <v-flex xs12 sm2 md2 v-if="choice">
                <h4 class="pt-4 text-body-2 dark--text">Carbs</h4>
              </v-flex>

              <v-flex xs12 sm4>
                <h4 class="text-body-2">
                  <v-select
                    @change="checkPackagePrice"
                    :items="[
                      { value: '50', text: '50' },
                      { value: '100', text: '100' },
                      { value: '150', text: '150' },
                      { value: '200', text: '200' },
                    ]"
                    v-model="carbs"
                    outlined
                    dense
                    type="number"
                    min="0"
                  >
                  </v-select>
                </h4>
              </v-flex>
            </v-layout>
            <v-layout v-if="choice" wrap>
              <v-flex xs12 sm2>
                <label class="pt-4 text-body-2 dark--text">Package Price</label>
              </v-flex>

              <v-flex xs12 sm4 lg4 pe-sm-6>
                <h4 class="text-body-2">
                  <v-text-field :value="parseFloat(mealChoice.price ? mealChoice.price : 0).toFixed(3)" solo disabled dense flat outlined>
                    <template v-slot:append>
                      <h4 class="mt-1 grey--text">KD</h4>
                    </template>
                  </v-text-field>
                </h4>
              </v-flex>

              <v-flex xs12 sm2 md2 v-if="choice">
                <h4 class="pt-4 text-body-2 dark--text">Discount</h4>
              </v-flex>

              <v-flex xs12 sm4>
                <h4 class="text-body-2">
                  <v-text-field v-model="discount" @change="onChoiceChange" :rules="positiveNo" type="number" min="0" solo dense flat outlined>
                    <template v-slot:append>
                      <h4 class="mt-1 grey--text">KD</h4>
                    </template>
                  </v-text-field>
                </h4>
              </v-flex>
            </v-layout>

            <v-layout v-if="choice">
              <v-flex xs12 sm2>
                <label class="pt-4 dark--text text-body-2">Additional Price</label>
              </v-flex>

              <v-flex xs12 sm4 lg4 pe-sm-6>
                <v-text-field :loading="additionalPriceLoading" v-model="additionalPrice" @change="onChoiceChange" solo :rules="positiveNoRule" type="number" min="0" dense flat outlined>
                  <template v-slot:append>
                    <h4 class="mt-1 grey--text">KD</h4>
                  </template>
                </v-text-field>
              </v-flex>
            </v-layout>

            <v-layout v-if="choice" wrap>
              <v-flex xs12 sm2>
                <h4 class="pt-4 text-body-2 dark--text">Total Price</h4>
              </v-flex>

              <v-flex xs12 sm4 pe-sm-6>
                <h4 class="text-body-2">
                  <v-text-field :value="netPrice" type="number" disabled color="red" solo dense flat outlined>
                    <template v-slot:append>
                      <h4 class="mt-1 grey--text">KD</h4>
                    </template>
                  </v-text-field>
                </h4>
              </v-flex>

              <v-flex xs12 sm2 v-if="parseFloat(netPrice) > 0">
                <h4 class="pt-4 text-body-2 dark--text">Payment Type</h4>
              </v-flex>

              <v-flex xs12 sm4 v-if="parseFloat(netPrice) > 0">
                <v-select
                  solo
                  dense
                  :rules="[requiredValidatorSelect('payment method')]"
                  attach
                  item-text="text"
                  item-value="value"
                  v-model="paymentMethod"
                  :items="avalilablePaymentMethod"
                  flat
                  outlined
                >
                </v-select>
              </v-flex>
            </v-layout>

            <div v-if="pacakageSelectionMethod">
              <v-layout wrap v-if="isNotAlreadyReferred()">
                <v-flex xs12 sm2>
                  <h4 class="text-body-2 dark--text mt-md-2">Referred By</h4>
                </v-flex>
                <v-flex xs12 sm4 pe-sm-6>
                  <v-text-field v-model="referredBy" solo dense flat outlined> </v-text-field>
                </v-flex>
              </v-layout>
            </div>
            <!-- <v-divider class="mb-6"></v-divider> -->

            <v-layout row class="mt-10" justify-end>
              <v-btn :width="$vuetify.breakpoint.xs ? 90 : 120" color="primary" class=" text-capitalize" @click="createSalesOrder()" :loading="btnloading" :disabled="!valid" depressed>Save</v-btn>
            </v-layout>
          </v-form>
        </v-container>
        <v-snackbar v-model="snackbar" timeout="3000" right top :color="snackColor">{{ text }}</v-snackbar>
        <!-- </v-container> -->

        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close">CLOSE</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { requiredValidator, requiredValidatorSelect, positive } from "../../../core/methods/validations";
import moment from "moment";
import { DATE_FORMAT, Utils } from "../../../utils/utils";

export default {
  components: {},
  props: {
    customer_id: {
      required: true,
    },
    customer: {
      required: true,
    },
    subscribedPackages: {
      required: true,
    },
  },

  watch: {
    subscribedPackages: {
      handler() {
        this.getActivePackage();
      },
      deep: true,
    },
    mealChoice: {
      handler() {
        this.packageCountListing();
      },
      deep: true,
    },
    choice: {
      handler() {
        this.mealChoice = "";
        this.availableDays = [];
      },
      deep: true,
    },

    selectPackage: {
      handler(item) {
        this.choice = "";
        this.mealChoice = "";
        this.availableDays = [];

        if (item.startDate) {
          let packageStartDate = moment(new Date(parseInt(item.startDate)));
          if (packageStartDate.isAfter(this.minDate)) {
            this.minDate = packageStartDate.format("YYYY-MM-DD");
          } else {
            this.minDate = this.packageSelectionDate.format("YYYY-MM-DD");
          }
        } else {
          this.minDate = this.packageSelectionDate.format("YYYY-MM-DD");
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.hasRole(this.AdminUserPermissions.PAYMENT_ONLINE)) {
      const data = this.paymentMethods[0];
      this.avalilablePaymentMethod.push(data);
    }
    if (this.hasRole(this.AdminUserPermissions.PAYMENT_OFFLINE)) {
      const data = this.paymentMethods[1];
      this.avalilablePaymentMethod.push(data);
    }
    if (this.hasRole(this.AdminUserPermissions.PAYMENT_FREE)) {
      const data = this.paymentMethods[2];
      this.avalilablePaymentMethod.push(data);
    }
    this.getActivePackage();
  },
  data() {
    return {
      //   nowDate: new Date().toISOString().slice(0,10),
      nowDate: moment()
        .add(3, "d")
        .toDate()
        .toISOString(),
      avalilablePaymentMethod: [],
      allCategories: [],
      allAvailableCategories: [],
      celebrityId: "",
      paymentMethods: [
        {
          value: "ONLINE",
          text: "Online",
        },
        {
          value: "OFFLINE",
          text: "Offline",
        },
        {
          value: "FREE",
          text: "Free",
        },
      ],
      paymentMethod: null,
      availableDays: "",
      listOfDays: [],
      tab: "",
      date: new Date(),
      netPrice: 0,
      landscape: false,
      discount: "",
      reactive: false,
      additionalPrice: "",
      additionalPriceLoading: false,
      additionalDays: "",
      choice: "",
      referredBy: "",
      mealChoice: "",
      start_date: "",
      menu1: false,
      activePackage: [],
      btnDisabled: false,
      snack: false,
      snackColor: "",
      snackText: "",
      hasActivePackage: false,
      hasUpcomingPackage: false,
      isValidIngredient: true,
      requiredValidator: requiredValidator,
      requiredValidatorSelect,
      positive,
      show_dialog_box: false,
      btnloading: false,
      valid: true,
      errors: [],
      snackbar: false,
      minDate: moment()
        .add(3, "day")
        .format("YYYY-MM-DD"),
      // .toDate()
      // .toISOString()
      text: "",
      pacakageSelectionMethod: "PACKAGE",
      celebrity: "",
      variables: {
        limit: 0,
        skip: 0,
      },
      packagesList: [],
      celebrities: [],
      selectedCelebrity: "",
      selectPackage: "",
      rdoCeleb: "",
      positiveNo: [v => v >= 0 || "Enter a valid discount"],
      positiveNoRule: [v => v >= 0 || "Value should be greater than 0"],
      protein: "",
      carbs: "",
      packageSelectionDate: moment(new Date()),
    };
  },
  //   created() {
  //     this.salesOrderTemp = JSON.parse(JSON.stringify(this.salesOrder));
  //   },
  apollo: {
    getAllPackages() {
      return {
        query: require("@/menu-packages/api/getAllPackagesWithChoice.graphql"),
        variables: this.variables,
        result({ data, loading }) {
          this.loading = loading;

          this.packagesList = data.getAllPackages.packages.filter(x => x.active);
          // console.log(data.getAllIngredients);
        },
      };
    },
    getAllCategories() {
      return {
        query: require("@/menu-packages/api/getAllCategories.graphql"),
        variables: this.variables,
        result({ data, loading }) {
          this.loading = loading;
          let allCategories = data.getAllCategories.category.filter(x => x.active == true);
          this.allAvailableCategories = JSON.parse(JSON.stringify(allCategories));
        },
      };
    },
    getMealSelectionDate() {
      return {
        query: require("./api/getMealSelectionDate.graphql"),
        variables: this.variables,
        result({ data, loading }) {
          this.loading = loading;

          let date = data.getMealSelectionDate.packageSelectionDate;
          this.packageSelectionDate = moment(new Date(parseInt(date)));
          if (this.packageSelectionDate.isAfter(this.minDate)) {
            this.minDate = this.packageSelectionDate.format("YYYY-MM-DD");
          }
        },
      };
    },
  },
  methods: {
    isAllowCustomerWeekDays(selectPackage) {
      if (selectPackage.allowedWeekDays) {
        if (selectPackage.allowedWeekDays.length > 0) {
          return true;
        }
      }
      return false;
    },
    packageCountListing() {
      this.availableDays = [];
      if (this.choice && this.mealChoice) {
        let choices = this.mealChoice;

        console.log(choices);
        let dayChoiceCategories = choices.dayChoices[0].mealCount.map(x => x.category._id);
        const filteredCategories = this.allAvailableCategories.filter(cat => dayChoiceCategories.includes(cat._id));
        this.allCategories = filteredCategories;

        this.allCategories.forEach(element => {
          element.count = 0;
        });
        this.listOfDays = [];

        let sunday = {
          day: "Sunday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };
        let monday = {
          day: "Monday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };
        let tuesday = {
          day: "Tuesday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };
        let wednesday = {
          day: "Wednesday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };
        let thursday = {
          day: "Thursday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };
        let friday = {
          day: "Friday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };
        let saturday = {
          day: "Saturday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };

        this.availableChoices = new Array();
        // let packageInfo = this.selectPackage;
        this.choice.availableDays.forEach(day => {
          switch (day) {
            case "Sunday": {
              sunday.allCategories.forEach(category => {
                let dayChoice = this.mealChoice.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(sunday);
              break;
            }
            case "Monday": {
              monday.allCategories.forEach(category => {
                let dayChoice = this.mealChoice.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(monday);
              break;
            }
            case "Tuesday": {
              tuesday.allCategories.forEach(category => {
                let dayChoice = this.mealChoice.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(tuesday);
              break;
            }
            case "Wednesday": {
              wednesday.allCategories.forEach(category => {
                let dayChoice = this.mealChoice.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(wednesday);
              break;
            }
            case "Thursday": {
              thursday.allCategories.forEach(category => {
                let dayChoice = this.mealChoice.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(thursday);
              break;
            }
            case "Friday": {
              friday.allCategories.forEach(category => {
                let dayChoice = this.mealChoice.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(friday);
              break;
            }
            case "Saturday": {
              saturday.allCategories.forEach(category => {
                let dayChoice = this.mealChoice.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(saturday);
              break;
            }
          }
        });
        this.listOfDays.push(sunday);
        this.listOfDays.push(monday);
        this.listOfDays.push(tuesday);
        this.listOfDays.push(wednesday);
        this.listOfDays.push(thursday);
        this.listOfDays.push(friday);
        this.listOfDays.push(saturday);
      }
    },
    packageChange() {
      (this.choice = ""), (this.protein = this.selectPackage.meanInfo.protein), (this.carbs = this.selectPackage.meanInfo.carbs);
    },
    onPackageModeChange() {
      this.celebrity = null;
      this.selectPackage = "";
      this.choice = "";
    },
    updateCelebityId(celebrity, packageItem) {
      this.celebrity = celebrity;
      this.selectPackage = packageItem;
    },
    isNotAlreadyReferred() {
      if (this.pacakageSelectionMethod == "CELEBRITY") {
        return false;
      }
      if (this.customer.referredByUser) {
        if (this.customer.isPackageSubscribed) {
          return true;
        }
        return false;
      }
      return true;
    },
    onChoiceChange() {
      if (this.mealChoice) {
        let price = parseFloat(this.mealChoice.price);
        let additionalPrice = parseFloat(this.additionalPrice ? this.additionalPrice : 0);
        let discount = this.discount ? parseFloat(this.discount) : 0;
        let netPrice = price - discount + additionalPrice;
        if (netPrice < 0) {
          discount = 0;
          this.discount = 0;
        }
        this.netPrice = (price - discount + additionalPrice).toFixed(3);
      }
    },

    getActivePackage() {
      let runningPackages = Utils.getActiveAndPendingCustomerPackages(this.subscribedPackages);
      this.currentPlanStatus(runningPackages);
    },

    currentPlanStatus(runningPackages) {
      this.hasActivePackage = false;
      this.hasUpcomingPackage = false;
      if (runningPackages.activePackage) {
        this.hasActivePackage = true;
      }
      if (runningPackages.upcomingPackage) {
        this.hasUpcomingPackage = true;
      }
    },
    close() {
      this.show_dialog_box = false;
      this.$refs.form.reset();
      this.selectPackage = "";
      this.start_date = "";
      this.choice = "";
    },

    createSalesOrder() {
      if (!this.valid) return false;

      let price = parseFloat(this.choice.price);
      let discount = this.discount ? parseFloat(this.discount) : 0;
      let netPrice = price - discount;
      if (this.pacakageSelectionMethod == "CELEBRITY") {
        if (this.celebrity) {
          this.referredBy = parseInt(this.celebrity.customer.user.userId).toString(16);
        }
      }

      if (!this.selectPackage || !this.selectPackage._id) {
        this.snackbar = true;
        this.snackColor = "error";
        this.text = "Please select a package";
        return false;
      }

      if (!this.choice || !this.choice._id) {
        this.snackbar = true;
        this.snackColor = "error";
        this.text = "Please select a choice";
        return false;
      }

      if (!this.mealChoice || !this.mealChoice._id) {
        this.snackbar = true;
        this.snackColor = "error";
        this.text = "Please select meal choice";
        return false;
      }

      let mealData = JSON.parse(JSON.stringify(this.availableDays));

      let isValid = true;
      let firstDay = this.availableDays[0];

      mealData.forEach(mealCount => {
        let hasMeal = false;
        mealCount.allCategories.forEach(category => {
          let firstDayCount = firstDay.allCategories.find(x => x._id == category._id);
          if (firstDayCount) {
            category.count = firstDayCount.count;
          }

          if (parseInt(category.count) > 0) {
            hasMeal = true;
          }
        });

        if (!hasMeal) {
          this.snackbar = true;
          this.snackColor = "error";
          this.text = "Please add atleast one meal on : " + mealCount.day;
          this.btnloading = false;
          isValid = false;
          return false;
        }
      });

      if (isValid) {
        let customerPackage = {};

        let dayChoices = new Array();

        this.availableDays.forEach(dayChoice => {
          let mealCounts = new Array();
          dayChoice.allCategories.forEach(element => {
            let firstDayCount = firstDay.allCategories.find(x => x._id == element._id);
            if (parseInt(firstDayCount.count) > 0) {
              let mealCount = {
                count: parseInt(firstDayCount.count),
                category: element._id,
              };
              mealCounts.push(mealCount);
            }
          });
          let dayChoiceItem = {
            day: dayChoice.day,
            mealCount: mealCounts,
          };
          dayChoices.push(dayChoiceItem);
        });

        customerPackage.dayChoices = dayChoices;
        let availableDays = this.availableDays.map(x => x.day);
        const subPackages = {
          package: this.selectPackage._id,
          start_date: this.start_date,
          selected_choice: this.choice._id,
          discount: discount,
          netPrice: netPrice,
          paymentMethod: this.paymentMethod,
          mealChoice: this.mealChoice._id,
          referralCode: this.referredBy,
          additionalDays: this.additionalDays ? parseInt(this.additionalDays) : 0,
          additionalPrice: this.additionalPrice ? parseFloat(this.additionalPrice) : 0,
          packageInfo: customerPackage,
          availableDays: availableDays,
          protein: this.protein,
          carbs: this.carbs,
        };

        this.btnloading = true;
        this.$apollo
          .mutate({
            mutation: require("../../api/adminCheckoutCustomerPackage.graphql"),
            variables: {
              input: subPackages,
              checkoutInput: {
                customerId: this.customer_id,
                paymentMethod: this.paymentMethod,
              },
            },
          })
          .then(data => {
            console.log(data);
            this.snackbar = true;
            this.text = "Customer sales order added";
            this.$root.$emit("updateGetCustomerById");
            this.snackColor = "success";
            this.$refs.form.reset();
            this.btnloading = false;
            this.close();
          })
          .catch(error => {
            this.snackbar = true;
            this.snackColor = "error";
            this.text = "Something went wrong";
            if (error.graphQLErrors != null) {
              console.error(error.graphQLErrors);
            }
            this.btnloading = false;
          });
      }
    },

    checkPackagePrice() {
      if (!this.selectPackage || !this.selectPackage._id) {
        return false;
      }

      if (!this.choice || !this.choice._id) {
        return false;
      }

      if (!this.mealChoice || !this.mealChoice._id) {
        return false;
      }

      if (this.availableDays == null || this.availableDays.length == 0) {
        return false;
      }
      let zerothData = this.availableDays[0];

      let mealCounts = new Array();
      zerothData.allCategories.forEach(category => {
        mealCounts.push({
          count: parseInt(category.count),
          category: category._id,
        });
      });

      // count: Int;
      // category: ID;
      debugger;
      let customizationInput = {
        packageId: this.selectPackage._id,
        choiceId: this.choice._id,
        variantId: this.mealChoice._id,
        mealCount: mealCounts,
        protein: parseInt(this.protein),
        carbs: parseInt(this.carbs),
        additionalDays: this.additionalDays ? parseInt(this.additionalDays) : 0,
      };

      let input = {
        packageId: this.selectPackage._id,
        selected_choice: this.choice._id,
        mealChoice: this.mealChoice._id,
        customization: customizationInput,
      };
      this.additionalPriceLoading = true;
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("../../api/applyPromoCode.graphql"),
          variables: {
            packageInput: input,
            shoppingInput: null,
            commonInput: {},
            customerId: this.customer_id,
          },
        })
        .then(data => {
          console.log(data);

          if (data.data.applyPromoCode) {
            if (data.data.applyPromoCode.additionalPrice < 0) {
              this.discount = Math.abs(data.data.applyPromoCode.additionalPrice).toFixed(3);
              this.additionalPrice = "0";
            } else if (data.data.applyPromoCode.additionalPrice > 0) {
              this.additionalPrice = data.data.applyPromoCode.additionalPrice.toFixed(3);
              this.discount = "0";
            } else {
              this.discount = "0";
              this.additionalPrice = "0";
            }
          }

          this.onChoiceChange();
          this.additionalPriceLoading = false;
          this.btnloading = false;
        })
        .catch(error => {
          this.snackbar = true;
          this.additionalPriceLoading = false;
          this.snackColor = "error";
          this.text = "Something went wrong";
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
        });
    },
  },
  computed: {
    formatDate() {
      return this.start_date ? moment(this.start_date).format(DATE_FORMAT) : "";
    },
  },
};
</script>
